import React from "react";
import PageLoader from "../../components/PageLoader";

import lazyPage from "../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/pages/homework/homework.tsx",
    () => import("./homework"),
    <PageLoader />,
);
